import { Component } from '@angular/core';
import { IAbstractView } from '@core/interfaces';
import { NotificationPresenter } from './notification.presenter';
import { INotificationComponent, INotificationPresenter } from './interfaces';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
	selector: 'app-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.scss'],
	imports: [CommonModule, IconComponent],
	standalone: true,
})
export class NotificationComponent extends IAbstractView<INotificationPresenter> implements INotificationComponent {
	notification$ = this.presenter.notification$;
	notification = this.presenter.notification;
	icon = this.presenter.icon;

	constructor(presenter: NotificationPresenter) {
		super(presenter);
	}

	notificationClass(): string {
		return this.presenter.notificationClass();
	}

	closeNotification(): void {
		this.presenter.closeNotification();
	}
}
